(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionsPastController', SessionsPastController);

    /* @ngInject */
    function SessionsPastController($rootScope, $scope, $state, $q, $filter, $mdSidenav, $location, Report, Media, CONTENT_META, Pubnub, Session, ParseLinks, pagingParams, paginationConstants, AlertService, $mdDialog, $mdToast, $stateParams, Feature, Experience, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.scheduleSession = Feature.isActive('feature_airsession_schedule_session');
        vm.sessionActivity = null;
        vm.sessionModel = null;
        vm.reOrder = reOrder;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.pageSize = paginationConstants.itemsPerPage;
        vm.panelToShow = null;
        vm.illustartionEmptyScreenId = "session_past";
        vm.illustartionEmptyScreenText = "There are no sessions yet";
        vm.removeFilter = removeFilter;
        vm.loadData = loadData;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };
        vm.filter.show = false;

        vm.permissions = {
            create: 'create-session',
            update: 'update-session',
            delete: 'delete-session',
            updatePersonalSession: 'update-personal-session'
        };

        vm.isLinkJobFeatureActive = Feature.isActive('feature_airsession_enable_air_session_link_with_job');
        vm.selectedJob = null;

        vm.isJobAlreadyLinked = function(session) { 
            var linkedResources = session && session.hasOwnProperty('linkedResources') && session.linkedResources.filter(function(linkedResource) {
                return linkedResource.linkType === 'Target' && linkedResource.resource.type === 'Job';
            }) || [];
            return linkedResources.length;
        };

        vm.openLinkJobDialog = function(session) {
            vm.sessionModel = session;
            var locals = {
                sessionNo: vm.sessionModel.session_no,
                sessionId: vm.sessionModel.id,
            };

            $mdDialog
                .show({
                    templateUrl: "modules/job/job-picker.tmpl.html",
                    controller: "JobPickerController",
                    controllerAs: "vm",
                    locals: locals,
                })
                .then(addLinkedJobDialogSuccess)
                .catch(function(error) {
                    vm.sessionModel = null;
                });
        };

        /**
         * Handles the success of the job linking API call.
         */
        function addLinkedJobDialogSuccess(job) {
            if (job && typeof job === "object" && job.hasOwnProperty("guid")) {
                vm.selectedJob = job;
                var data = {
                    air_session_id: vm.sessionModel.id,
                    job_id: job.guid,
                };
                Session.linkJob(
                    {},
                    data,
                    handleAddLinkedApiJobSuccess,
                    addLinkedJobApiError
                );
            }
        }

        /**
         * Creates the linked resources for the session job link.
         * @param {Object} job - The job to create the linked resources for.
         * @returns {Object} The linked resources for the session job link.
         */
        vm.createLinkedResourcesForSessionJobLink = function (job) {
            return {
                linkType: "Target",
                resource: {
                    name: "jobRef",
                    type: "Job",
                    id: job.guid,
                },
                properties: {
                    jobNumber: job.jobNumber,
                    jobName: job.airformRef.name,
                },
            };
        };

        /**
         * Handles the success of the job linking API call.
         */
        function handleAddLinkedApiJobSuccess() {
            var linkedResource = vm.createLinkedResourcesForSessionJobLink(vm.selectedJob);
            vm.sessionModel.linkedResources = [
                linkedResource
            ];
            handleUpdateResources("add", vm.selectedJob);
            vm.selectedJob = null;
        }

        function handleUpdateResources(action, job) {
            var payload = {
                action: action,
                job: job,
                session: vm.sessionModel,
            };
            $rootScope.$emit("updateSessionLinkedJobsResource", payload);
            $rootScope.$emit("refreshSessionLinkedJobsResource");
            vm.selectedJob = null;
        }

        /**
         * Handles the error of the job linking API call.
         * @param {Object} error - The error object.
         */
        function addLinkedJobApiError(error) {
            vm.selectedJob = null;
            ToastService.displayToast(
                error.status >= 400 &&
                    error.status < 500 &&
                    !!error.data.description
                    ? error.data.description
                    : $filter("translate")(
                          "atheer.session.insights.linkingAirSessionFailed"
                      ),
                3000
            );
        }

        vm.createObject = function() {
            $state.go('storm.sessions.upcoming-detail');
        };

        vm.deleteObject = function(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.session.upcomingSessions.deleteSession'))
                .ariaLabel($filter('translate')('atheer.session.upcomingSessions.deleteSession'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Session.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

       vm.editObject = function(entity) {
            $mdDialog.show({
                templateUrl: 'modules/session/session-past-edit.tmpl.html',
                clickOutsideToClose: true,
                controller: "SessionPastEditController",
                controllerAs: "vm",
                 locals: {
                       filter: entity.id
                    }
            }).then(function(result) {
                resetModal();
            });
        };

        function resetModal() {
            loadData();
            AlertService.displayToast($mdToast);
        };

        vm.togglePanel = function(componentId, session) {
            vm.sessionModel = null;
            if (session) {
                vm.sessionModel = session;
            }
            if(componentId == 'insightsPanel') {
                vm.panelToShow = 'insightsPanel';
            } else if (componentId == 'annotationsPanel') {
                vm.panelToShow = 'annotationsPanel';
            } else if (componentId == 'recordingsPanel'){
                vm.panelToShow = 'recordingsPanel';
            } else if (componentId == 'conversationPanel') {
                vm.panelToShow = 'conversationPanel';
            }

            $mdSidenav(componentId).toggle()
                .then(function() {

                });
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        }

        vm.refresh = function() {
            loadData();
        };

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        };

        function transition() {
            vm.promise = Session.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                previous: true
            }).$promise;

            function sort() {
                var result = [getSortOrder()];

                return result;
            }

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.sessions = data;
            });
        };

        function getSortOrder() {
            if (vm.predicate.startsWith('id')) {
                return vm.predicate + ',' + 'desc';
            }

            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }
        };

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        }

        function getQueryString() {
            var query = '';
            if (vm.query.filter.length > 0) {
                query = query + '(text_search=' + vm.query.filter + ')';
            }
            return query;
        };

        function loadData() {
            vm.loadingData = true;
            Session.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                previous: true
            }, onSuccess, onError);

            function sort() {
                var result = [getSortOrder()];

                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sessions = data;
                vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        };

        var refreshSessionListener = $rootScope.$on('refreshSessions', function(event, filter) {
            vm.query.filter = filter;
            loadData();
        });

        /**
         * Listens for the updateSessionLinkedJobsResource event and updates the session linked jobs resource.
         */
        var updateSessionLinkedJobsResourceListener = $rootScope.$on(
            "updateSessionLinkedJobsResource",
            function (event, payload) {
                vm.sessions = vm.sessions.map(function (s) {
                    if (s.id === payload.session.id) {
                        return payload.session;
                    }
                    return s;
                });
            }
        );

        // Unregister
        $scope.$on('$destroy', function() {
            refreshSessionListener();
            updateSessionLinkedJobsResourceListener();
        });

        loadData();
    }
})();
